export default __webpack_public_path__ + "static/media/tetrahedron.a8789f5e.obj";